import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportProcessFlows_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportProcessFlows extends Report<ReportProcessFlows_Settings> {

    static reportName   : string = "Process flows"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_PROCESS_FLOWS
        super(data);

        this.icon        = "isvg-process-flow"
        this.name           = data.name || "Process Flows"
        this.description = "Analyzes process efficiency, identifying bottlenecks and areas for improvement."

        this.settings    = new ReportProcessFlows_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportProcessFlows {
        return new ReportProcessFlows(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportProcessFlows_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }


    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)
    }
}
